import ImageWithFallback from "@/components/ImageWithFallback";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";

export const columns = () => {
  const booleanOptionLabelsMap = booleanOptionIconLabels();

  return [
    {
      id: "show_in_profile",
      accessorFn: (row) => booleanOptionLabelsMap[row.show_in_profile],
      header: "Show Profile?",
      cell: ({ getValue }) => (
        <div className={"flex justify-center"}>{getValue()}</div>
      ),
    },
    {
      accessorKey: "id",
      header: "Event ID",
    },
    {
      accessorKey: "name",
      header: "Event Name",
    },
    {
      accessorKey: "competition",
      header: "Competition ID",
      cell: ({ row }) => <div>{row.original?.competition?.code || "-"}</div>,
    },
    {
      accessorKey: "terms",
      header: "Term ID",
      cell: ({ row }) => <div>{row.original?.term?.code || "-"}</div>,
    },
    {
      accessorKey: "total_teams",
      header: "# of Teams",
    },
    {
      accessorKey: "start_date",
      header: "Start Date",
    },
    {
      accessorKey: "end_date",
      header: "End Date",
    },
    {
      accessorKey: "host_country",
      header: "Host Country",
      cell: ({ row }) => <div>{row.original?.host_country?.name || "-"}</div>,
    },
    {
      accessorKey: "final_city",
      header: "Final City",
      cell: ({ row }) => <div>{row.original?.final_city?.name || "-"}</div>,
    },
    {
      accessorKey: "final_stadium",
      header: "Final Stadium",
    },
    {
      accessorKey: "banner_url",
      header: "Banner",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("banner_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "thumbnail_url",
      header: "Thumbnail",
      cell: ({ row }) => (
        <ImageWithFallback url={row.getValue("thumbnail_url")} />
      ),
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
